'use client';

import { useAccountInfo } from '@/hooks/query/account';
import { SearchBar } from './component/search-bar';
import { SearchContainer } from './component/search-container';
import { useGetAutocomplete } from '@/hooks/query/use-search-data';
import { useState } from 'react';
import { SearchResult } from './component/types';

export const SearchComponent = () => {
	const { user } = useAccountInfo();
	const { data } = useGetAutocomplete({
		userlanguage: user?.Lang ?? 'en-US',
	});
	const [autoCompleteResults, setAutoCompleteResults] = useState<Array<string>>([]);
	const [searchResults, setSearchResults] = useState<Array<SearchResult>>([]);
	return (
		<div className="search">
			<SearchBar 
				autoCompleteDatas={data}
				setAutoCompleteResults={setAutoCompleteResults}
				setSearchResults={setSearchResults}
				autoCompleteResults={autoCompleteResults}
			/>
			<SearchContainer
				searchResults={searchResults}
				setSearchResults={setSearchResults}
			/>
		</div>
	)
}
